import React, { Component } from 'react';
import { Field } from 'redux-form';

import {renderErrorAlert, renderField} from "../Common/RenderFieldTypes";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    onSubmit(val) {
        this.setState({submitError: ''});
        return this.props.authenticate(val).then((response) => {
            if (response.payload) {
                if (response.payload.name === 'ValidationError') {
                    this.setState({
                        submitError: 'There was an error submitting. Please try again.'
                    });
                } else if (!response.payload.success) {
                    this.setState({
                        submitError: 'Username/password invalid.'
                    });
                } else {
                    this.props.history.push(`/`);
                }
            } else {
                this.setState({
                    submitError: 'There was an error submitting. Please try again.'
                });
            }
        });
    }

    render() {
        const { handleSubmit, pristine, submitting, submitFailed, error  } = this.props;
        return (
            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <div className="row">
                    <div className="col-12 col-sm-8 col-md-6 col-lg-5">
                        <Field name="username" className="form-control" component={renderField} type={"text"} label="Username" id="username" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-8 col-md-6 col-lg-5">
                        <Field name="password" className="form-control" component={renderField} type={"password"} label="Password" id="password"/>
                    </div>
                </div>
                <div id="submitArea">
                    <button type="submit" className="btn btn-success float-left" disabled={pristine || submitting}>
                        {submitting ? 'Logging In...' : 'Login'}
                    </button>
                    {renderErrorAlert(submitFailed, error, this.state.submitError)}
                </div>
            </form>
        )
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Auth/Login.js